var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconVerified(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#275D38"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.68308 13.3171L5.18308 10.8171C5.06586 10.6999 5 10.5409 5 10.3751C5 10.2093 5.06586 10.0503 5.18308 9.93308C5.30031 9.81586 5.4593 9.75 5.62508 9.75C5.79086 9.75 5.94986 9.81586 6.06708 9.93308L8.12508 11.9911L13.9331 6.18308C13.9911 6.12504 14.06 6.079 14.1359 6.04758C14.2117 6.01617 14.293 6 14.3751 6C14.4572 6 14.5385 6.01617 14.6143 6.04758C14.6901 6.079 14.759 6.12504 14.8171 6.18308C14.8751 6.24113 14.9212 6.31004 14.9526 6.38587C14.984 6.46171 15.0002 6.543 15.0002 6.62508C15.0002 6.70717 14.984 6.78845 14.9526 6.86429C14.9212 6.94013 14.8751 7.00904 14.8171 7.06708L8.56708 13.3171C8.50904 13.3751 8.44014 13.4212 8.3643 13.4526C8.28846 13.484 8.20717 13.5002 8.12508 13.5002C8.04299 13.5002 7.96171 13.484 7.88587 13.4526C7.81003 13.4212 7.74112 13.3751 7.68308 13.3171Z",
    fill: "white",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVerified);
export default __webpack_public_path__ + "static/media/iconVerified.01af0c24e60c6387e573d8d892ac3bb0.svg";
export { ForwardRef as ReactComponent };